export type ScheduleTime = {
  hour: number;
  minute: number;
};

export function parseTime(timeString: string): ScheduleTime {
  if (!timeString) return undefined;
  if (!validateTime(timeString)) return undefined;
  const splitTime = timeString.split(':');
  const [hour, minute] = splitTime;
  return {
    hour: +hour,
    minute: +minute,
  };
}

export function withinSchedule(
  startTime: ScheduleTime,
  endTime: ScheduleTime,
  selectedTime: ScheduleTime
) {
  if (!startTime || !endTime || !selectedTime) return false;
  const isSelectedGreaterEqThanStart = greaterThanOrEqualTime(
    selectedTime,
    startTime
  );
  const isEndGreaterEqThanSelected = greaterThanOrEqualTime(
    endTime,
    selectedTime
  );
  if (isSelectedGreaterEqThanStart && isEndGreaterEqThanSelected) return true;
  return false;
}

export function greaterThanTime(timeA: ScheduleTime, timeB: ScheduleTime) {
  if (timeA.hour > timeB.hour) return true;
  if (timeA.hour < timeB.hour) return false;
  if (timeA.minute > timeB.minute) return true;
  if (timeA.minute < timeB.minute) return false;
  return false;
}

export function greaterThanOrEqualTime(
  timeA: ScheduleTime,
  timeB: ScheduleTime
) {
  if (timeA.hour > timeB.hour) return true;
  if (timeA.hour < timeB.hour) return false;
  if (timeA.minute > timeB.minute) return true;
  if (timeA.minute < timeB.minute) return false;
  if (timeA.hour === timeB.hour && timeA.minute === timeB.minute) return true;
  return false;
}

export function validateTime(timeString: string): boolean {
  if (!timeString) return false;
  if (timeString.includes(':')) {
    const regexPattern = /([0-9]|[01][0-9]|2[0-9]):[0-5][0-9]/g;
    if (timeString.match(regexPattern)) {
      return true;
    }
    return false;
  } else {
    return false;
  }
}
